import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=77361b60&lang=pug&"
import script from "./camera.vue?vue&type=script&lang=js&"
export * from "./camera.vue?vue&type=script&lang=js&"
import style0 from "./camera.vue?vue&type=style&index=0&id=77361b60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports